import Header from './Header';
import './styles/Quote.css';

const Quote = () => (
  <div>
    <Header />
    <p className="p">
      Mathematics is not about numbers, equations, computations,
      or algorithms: it is about understanding. -William Paul Thurston
    </p>
  </div>
);

export default Quote;
